"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgPolicyActivated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 122,
    viewBox: "0 0 105 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 96.5,
    r: 23,
    stroke: props.color || "#133251",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 96.5l8.85 8.17L91.5 88",
    stroke: props.color || "#133251",
    strokeWidth: 5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.012 46.246l-.006-.005c-4.25-3.724-6.564-8.717-6.494-18.712 5.394-2 8.977-3.709 14.557-7.955 5.447 4.245 9.036 5.957 14.42 7.953-.03 5.027-.652 8.736-1.743 11.65-1.1 2.94-2.723 5.19-4.91 7.222-3.5 3.091-7.051 3.09-7.819 3.09h-.285c-.957 0-4.373-.292-7.72-3.243z",
    stroke: props.color || "#133251",
    strokeWidth: 5.02
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 61H17.01c-.022 0 0 5 0 5H63v-5zM48 74H17.006c-.014 0 0 5 0 5H48v-5zM89.14.006C81.834.627 76.15 6.456 76 13.773V28h13.14v-5H81v-9c0-5 4-9 9-9L89.14.006z",
    fill: props.color || "#133251"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81 22.98h-5.02v48.143a25.79 25.79 0 015.02-.002v-43.12h5.02L102.788 28c1.181 0 2.212-1.03 2.212-2.212V13.7C104.85 6.33 99.32.587 91.949 0H13.134C5.762.588.014 6.928.014 14.3c0 18.282-.003 32.786-.007 47.29C.004 76.095 0 90.6 0 108.881.587 116.253 6.928 122 14.3 122h62.307a4.4 4.4 0 00.554-.035 25.366 25.366 0 01-13.857-4.985H14.3c-4.74 0-8.816-3.688-9.28-8.321 0-18.174.004-32.617.008-47.06v-.007c.004-14.505.007-29.01.007-47.292 0-4.74 3.688-8.816 8.321-9.28H91.73c4.754.462 8.134 4.086 8.25 8.736v9.224H81z",
    fill: props.color || "#133251"
  }));
}

var _default = SvgPolicyActivated;
exports["default"] = _default;